/* __next_internal_client_entry_do_not_use__ default auto */ import * as React from 'react';
/**
 * @ignore - internal component.
 */ const ButtonGroupButtonContext = /*#__PURE__*/ React.createContext(undefined);
if ("production" !== 'production') {
    ButtonGroupButtonContext.displayName = 'ButtonGroupButtonContext';
}
export default ButtonGroupButtonContext;
